<script lang="ts" setup>
import { inject, watch, ref } from 'vue';

import type { Ref } from 'vue';
import type { Viewer } from '@immersive-tech/viewer-engine';
import type { IManifest } from '@/types/IManifest';

const viewer = inject('viewer') as Ref<Viewer>;
const manifest = inject('manifest') as Ref<IManifest>;
const intensity = ref(manifest.value.envMapIntensity);

const intensityWatcher = (newValue: number, oldValue: number) => {
  if (newValue === oldValue) return;

  manifest.value.envMapIntensity = Number(newValue);
  viewer.value.environmentMapIntensity = Number(newValue);
};

const manifestWatcher = (newValue: IManifest, oldValue: IManifest) => {
  if (newValue.envMapIntensity === oldValue.envMapIntensity) return;

  intensity.value = Number(newValue.envMapIntensity);
};

watch(intensity, intensityWatcher);
watch(manifest, manifestWatcher);
</script>

<template>
  <div class="flex flex-row mb-1 items-center">
    <label for="envmap-intensity" class="text-xs mr-2">Intensity <span class="font-normal">({{ Number(manifest.envMapIntensity).toFixed(2) }})</span></label>
    <input
      id="envmap-intensity"
      v-model="intensity"
      type="range"
      step="0.01"
      min="0"
      max="10"
      class="border p-1 text-xs flex-grow"
    >
  </div>
</template>
